module.exports = __webpack_public_path__ + "assets/images/purpelShade.39efd5df8ca72b80275fd1577d679e56.png";